<template>
  <div
    class="el-upload-dragger"
    :class="{
      'is-dragover': dragover
    }"
    @drop.prevent="onDrop"
    @dragover.prevent="onDragover"
    @dragleave.prevent="dragover = false"
  >
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ElUploadDrag',
    props: {
      disabled: Boolean
    },
    inject: {
      uploader: {
        default: ''
      }
    },
    data() {
      return {
        dragover: false
      };
    },
    methods: {
      onDragover() {
        if (!this.disabled) {
          this.dragover = true;
        }
      },
      onDrop(e) {
        if (this.disabled || !this.uploader) return;
        const accept = this.uploader.accept;
        this.dragover = false;

        //console.log(`onDrop: type of first file = ${JSON.stringify(e.dataTransfer.files[0].type)}`);

        const inputFiles = [];


        function traverseFileTree(item, path) {
          //console.log(`traverseFileTree: triggered, path = ${path}, name = ${item.name}`);
          path = path || "";

          function readAllEntries(reader) {
            return new Promise(
              resolve => {
                const prmsTraverse = [];
                reader.readEntries(function(entries) {
                  if (!entries.length) {
                    resolve(true);
                  }
                  else {
                    //console.log(`traverseFileTree: readEntries triggered, path = ${path}, name = ${item.name}`);
                    for (var i=0; i<entries.length; i++) {
                      prmsTraverse.push(traverseFileTree(entries[i], path + item.name + "/"));
                    }
                    Promise.all(prmsTraverse).finally(() => {
                      readAllEntries(reader).finally(() => {
                        resolve(true);
                      })
                    })
                  }
                });
              }
            );
          }

          if (item.isFile) {
            // Get file
            return new Promise(
              resolve => {
                item.file(function(file) {
                  //NOTE: we set the "pathName" attr to the rawFile
                  file.pathName = path + file.name;
                  inputFiles.push(file);
                  //console.log("File:", path + file.name);
                  resolve(true);
                });
              }
            )
          } else if (item.isDirectory) {
            // Get folder contents
            var dirReader = item.createReader();

            return readAllEntries(dirReader);

          }
        }

        const prms = [];
        var items = e.dataTransfer.items;
        for (var i=0; i<items.length; i++) {
          var item = items[i].webkitGetAsEntry();
          if (item) {
            prms.push(traverseFileTree(item));
          }
        }

        Promise.all(prms).finally(() => {
          //console.log(`onDrop: prms.all, inputFiles = ${JSON.stringify(inputFiles)}`);
          //console.log(`onDrop: prms.all, inputFiles.length = ${inputFiles.length}`);

          if (!accept) {
            //this.$emit('file', e.dataTransfer.files);
            this.$emit('file', inputFiles, true);
            return;
          }

          //this.$emit('file', [].slice.call(e.dataTransfer.files).filter(file => {
          this.$emit('file', [].slice.call(inputFiles).filter(file => {
            const { type, name } = file;
            const extension = name.indexOf('.') > -1
              ? `.${ name.split('.').pop().toLowerCase() }`
              : '';
            const baseType = type.replace(/\/.*$/, '');
            //console.log(`dragged: type = ${type}, baseType = ${baseType}, extension = [${extension}]`);
            return accept.split(',')
              .map(type => type.trim())
              .filter(type => type)
              .some(acceptedType => {
                if (/\..+$/.test(acceptedType)) {
                  return extension === acceptedType;
                }
                if (/\/\*$/.test(acceptedType)) {
                  return baseType === acceptedType.replace(/\/\*$/, '');
                }
                if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
                  return type === acceptedType;
                }
                return false;
              });
          }), true);
        });
      }
    }
  };
</script>

